export type GiftOption = {
  id: "hai-vung" | "ba-vung" | "bo-pha";
  name: string;
  subtitle: string;
  price: number;
  contents: string[];
  note: string;
};

export const giftOptions: GiftOption[] = [
  {
    id: "hai-vung",
    name: "Hộp 2 trà",
    subtitle: "Bạch trà và hồng trà, kèm thiệp.",
    price: 540_000,
    contents: ["Bạch Suối Giàng 45 g", "Hồng Hoàng Su Phì 60 g", "Thiệp giấy sợi"],
    note: "Hợp để tặng đồng nghiệp hoặc một người mới bắt đầu uống trà.",
  },
  {
    id: "ba-vung",
    name: "Hộp 3 trà",
    subtitle: "Đủ ba vùng trà trong tuyển chọn.",
    price: 760_000,
    contents: ["Bạch Suối Giàng 45 g", "Hồng Hoàng Su Phì 60 g", "Ô long Tà Xùa 55 g", "Thiệp giấy sợi"],
    note: "Lựa chọn cân bằng, có đủ vị thanh, tròn và đậm.",
  },
  {
    id: "bo-pha",
    name: "Bộ trà và dụng cụ",
    subtitle: "Ba trà, bình thủy tinh và hai chén.",
    price: 1_080_000,
    contents: ["Ba lon trà tuyển chọn", "Bình thủy tinh 350 ml", "Hai chén trà", "Thiệp giấy sợi"],
    note: "Dành cho một dịp quan trọng hoặc cả gia đình cùng mở hộp.",
  },
];

export const teaLayers = [
  {
    name: "Bạch Suối Giàng",
    type: "Bạch trà",
    origin: "Suối Giàng, Yên Bái",
    taste: "Hoa trắng, mía non, hậu vị mát",
    brew: "82°C · 4 g · 90 giây",
  },
  {
    name: "Ô long Tà Xùa",
    type: "Ô long nhẹ",
    origin: "Tà Xùa, Sơn La",
    taste: "Lá thơm, quả vàng, khoáng nhẹ",
    brew: "88°C · 5 g · 75 giây",
  },
  {
    name: "Hồng Hoàng Su Phì",
    type: "Hồng trà",
    origin: "Hoàng Su Phì, Hà Giang",
    taste: "Mật mía, vỏ quýt, gỗ khô",
    brew: "92°C · 5 g · 60 giây",
  },
];

export const finishOptions = [
  { id: "bac-suong", label: "Thiếc mờ", description: "Hộp than chì, giấy lót màu thiếc" },
  { id: "xanh-vu", label: "Xanh cobalt", description: "Hộp than chì, dải giấy xanh cobalt" },
] as const;
